import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue";
import i18n from "@/plugins/i18n";
import StakeManagementIcon, { StakeManagementIconType }from "@/components/commons/StakeManagementIcon.vue";
import { DropdownChangeEvent } from "primevue/dropdown";
import { StakingAction } from "@/components/staking/StakingAction.ts";
import { getRedelagatePlaceholder, RedelegationDirection } from "@/components/staking/StakingRedelegate.ts";

interface ActionData {
  type: StakingAction,
  name: string,
  icon: StakeManagementIconType
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StakingAction',
  props: {
  disabled: {
    type: Boolean,
    default: false
  },
  modelValue: Number,
  redelegationDirection: {
    type: String as PropType<RedelegationDirection>,
    required: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const props = __props;

function onValueChange(e: DropdownChangeEvent) {
  emit('update:modelValue', e.value.type);
}

const defualtAction: ActionData = {type: StakingAction.DELEGATE, name: i18n.global.t('STAKING_VIEW.STAKING_POPUP.DELEGATE'), icon: 'delegate'};
const actions: ActionData[] = [
  defualtAction,
  {type: StakingAction.UNDELEGATE, name: i18n.global.t('STAKING_VIEW.STAKING_POPUP.UNDELEGATE'), icon: 'undelegate'},
  {type: StakingAction.REDELEGATE, name: getRedelagatePlaceholder(props.redelegationDirection), icon: 'redelegate'},
  ];

const stakingAction = ref<ActionData | undefined>(actions.find((val) => {return val.type === props.modelValue;}));


const __returned__ = { emit, props, onValueChange, defualtAction, actions, stakingAction, StakeManagementIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})